import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

import Component from './component'
import WithTranslation from '../../../../../globals/components/withTranslation'
import WithPermissions from '../../../../../globals/components/withPermissions'

export default compose(WithTranslation, WithPermissions, withRouter)(Component)
